import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

/**
 * Lightweight activity logging hook.
 * Logs user actions to /activity/log for statistics.
 * Fire-and-forget — never blocks UI, never throws.
 */
export function useActivityLog() {
  const { user } = useAuth();

  const logActivity = useCallback((action, details = {}, page = '') => {
    if (!user) return;
    try {
      api.post('/activity/log', null, {
        params: {
          action,
          page: page || window.location.pathname,
          details: JSON.stringify(details),
        }
      }).catch(() => {}); // fire-and-forget
    } catch {
      // never throw
    }
  }, [user]);

  return logActivity;
}
